// Copyright (c) 2017 Deere & Company

import auditStatus from './audit-status';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';

export const getCombinedReducers = () => combineReducers({
    auditStatus,
    busyCounter,
    showNoResultsFound
});



// WEBPACK FOOTER //
// ./src/reports/audit-status/reducers/index.js